<template>
  <div>
    <div class="row pt-1" v-if="berechtigungen.m_geschaeftspartner.read">
      <div class="col-lg-12">
        <div class="tile-categorie-frame">
          <div class="tile-categorie">
            <div class="header">
              <span>{{ $t("global.mediations") }}</span>
            </div>
            <div class="body">
              <div class="row">
                <!-- Start Angebote -->
                <div class="col-xl-4">
                  <div class="tile-frame centered h-2">
                    <router-link to="/angebote">
                      <div class="tile bg-turkis inverted">
                        <div class="icon-container fa-container">
                          <font-awesome-icon icon="fa-duotone fa-wheat" />
                        </div>
                        <div class="title">
                          <div>{{ $t("global.offers") }}</div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
                <!-- Ende Angebote -->

                <!-- Start Zeitraumliste -->
                <div class="col-xl-4">
                  <div class="tile-frame centered h-2">
                    <router-link :to="{ name: 'Zeitraumliste' }">
                      <div class="tile bg-light-turkis inverted">
                        <div class="icon-container fa-container">
                          <font-awesome-icon
                            icon="fa-duotone fa-calendar-image"
                          />
                        </div>
                        <div class="title">
                          {{ $t("global.periods") }}
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
                <!-- Ende Zeitraumliste -->

                <!-- Start Einsatzliste -->
                <div class="col-xl-4">
                  <div class="tile-frame centered h-2">
                    <router-link :to="{ name: 'Einsatzliste' }">
                      <div class="tile bg-light-turkis inverted">
                        <div class="icon-container fa-container">
                          <font-awesome-icon
                            icon="fa-duotone fa-money-bill-wheat"
                          />
                        </div>
                        <div class="title">
                          {{ $t("global.deployments") }}
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
                <!-- Ende Einsatzliste -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row pt-1" v-if="berechtigungen.m_geschaeftspartner.read">
      <div class="col-lg-12">
        <div class="tile-categorie-frame">
          <div class="tile-categorie">
            <div class="header">
              <span>{{ $t("global.dashboard_crm") }}</span>
            </div>
            <div class="body">
              <div class="row">
                <!-- Start Personen -->
                <div class="col-xl-6">
                  <div class="tile-frame left-aligned h-1">
                    <router-link to="/personenliste">
                      <div class="tile bg-med-green inverted">
                        <div class="icon-container fa-container">
                          <font-awesome-icon
                            icon="fa-duotone fa-user-friends"
                            fixed-width
                          />
                        </div>
                        <div class="title">
                          <div>{{ $t("global.contacts") }}</div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
                <!-- Ende Personen -->

                <!-- Start Unternehmen -->
                <div class="col-xl-6">
                  <div class="tile-frame left-aligned h-1">
                    <router-link to="/unternehmensliste">
                      <div class="tile bg-med-green inverted">
                        <div class="icon-container fa-container">
                          <font-awesome-icon icon="fa-duotone fa-building" />
                        </div>
                        <div class="title">
                          <div>
                            {{ $t("global.companiesandfarms") }}
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
                <!-- Ende Unternehmen -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StartseiteCRMNewViva",
};
</script>
